import { host } from "host/host";

const MAC_TRAFFIC_LIGHT_INSET = 96;

export const HeaderTrafficInset = () => {
    if (host !== "mac") return null;

    return (
        <div
            aria-hidden="true"
            className="flex-none"
            style={{ width: MAC_TRAFFIC_LIGHT_INSET }}
        />
    );
};
